export default __webpack_public_path__ + "static/media/itemsConsolidation.e1f5089c.svg";